import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../App.css';
import { useUser } from '../context/UserContext';

const Home = () => {
    const navigate = useNavigate();
    const { hasPermission } = useUser();

    useEffect(() => {
        const checkAccess = async () => {
            const modules = [
                { path: '/admin/dashboard', module: 'admin', action: 'view' },
                { path: '/nfc-scanner', module: 'nfc', action: 'scan' },
                { path: '/nfc-management', module: 'nfc', action: 'view' },
                { path: '/checkpoints', module: 'checkpoints', action: 'view' },
            ];

            for (const { path, module, action } of modules) {
                const hasAccess = await hasPermission(module, action);
                if (hasAccess) {
                    navigate(path);
                    return;
                }
            }
        };
        checkAccess();
    }, [navigate, hasPermission]);

    return null;
};

export default Home;